// extracted by mini-css-extract-plugin
export var infoRow = "_ob-2";
export var labelContainer = "_ob-0";
export var rightInfo = "_ob-1";